import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceEfficiency(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_FINANCE_EFFICIENCY,
		ModulesConfigMap[ModulesMap.REPORTS_FINANCE_EFFICIENCY].GET_REPORTS_FINANCE_EFFICIENCY,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_EFFICIENCY].GET_REPORTS_FINANCE_EFFICIENCY]: _getReportsFinanceEfficiency,
}